<script>
  // import Layout from '@layout/main'
  import ContactLayout from './components/MenuList'

  export default {
    page() {
      return {
        title: `營業據點 | 關於我們`,
      }
    },
    components: {
      ContactLayout,
    },
    data() {
      return {
        activeName: 0,
        trafficInfo: [
          {
            title: '捷運資訊',
            content: '文湖線【西湖站】2號出口(步行約6分鐘) <br> 文湖線【港墘站】2號出口(步行約12分鐘)'
          },
          {
            title: '公車資訊',
            content: '麗山街<br>21、28、214、222、247、247區間車、267、286、286副、287區間車、268、 620、646、646區間車、677、683、946、紅2、紅31、藍26、內湖幹線、內科通勤19、淡水-內湖科技園區-南港車站跳蛙公車<br><br><br>仁寶大樓<br>21直達車、286、552、645、645副、902、902區間車、950、956、1573、紅3、紅31、綠16、藍27 棕20、泰山-內湖跳蛙公車、內科通勤2、3、5、6、7、8、9、10、11、12、13、15、16、17、18、20、內科通勤-圓山直達車、內科通勤-市府直達車'
          },
          {
            title: '停車資訊',
            content: '洲子立體停車場：請由瑞光路513巷22弄進入(每小時20元)<br>捷運西湖站東側平面停車場'
          }
        ],
        otherSite: [
          {
            title: '總公司',
            map: '台北市內湖區內湖路一段360巷8號10樓',
            tel: '(02)2656-5656',
            fax: '(02)2656-0810'
          },
          {
            title: '倉庫・維修中心',
            map: '台北市內湖區瑞光路513巷22弄5號5樓',
            tel: '(02)2656-5650',
            fax: '(02)2657-6455'
          },
          {
            title: '新竹辦公室',
            map: '新竹巿東區慈雲路118號17樓之3',
            tel: '(03)668-6638',
            fax: '(03)668-6856'
          },
          {
            title: '台中辦公室',
            map: '台中市西區忠明南路497號15樓A1室',
            tel: '(04)2373-0908',
            fax: '(04)2373-0398'
          },
          {
            title: '高雄辦公室',
            map: '高雄市左營區至聖路200號5樓502室',
            tel: '(07)535-3773',
            fax: '(07)535-3776'
          },
          {
            title: '零宇學苑',
            map: '台北市內湖區瑞光路513巷35號6樓',
            tel: '(02)2656-0777',
            fax: null
          }
        ]
      }
    }
  }
</script>
<template>
  <ContactLayout>
    <div :class="$style.location">
      <section class="section container ">
        <!-- <div class="row location__head＿list">
          <div class="col-md-5 location__head__item">
            <div class="img"></div>
          </div>
          <div class="col-md-7 location__head__item">
            <div class="location__head__item--right">
              <BaseSectionTitle2 title="總公司" />
              <ul class="list-unstyled">
                <li>
                    地址：
                    <a 
                      href="https://www.google.com.tw/maps/search/台北市內湖區內湖路一段360巷8號10樓"
                      targer="_blank"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      台北市內湖區內湖路一段360巷8號10樓
                    </a>
                </li>
                <li>
                    電話：
                    <a 
                      href="tel:(02)2656-5656"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      (02)2656-5656
                    </a>
                </li>
                <li>
                    傳真：
                    <a 
                      href="tel:(02)2656-0810"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      (02)2656-0810
                    </a>
                </li>
                
              </ul>
              <p class="my-4">交通資訊：</p>
              <el-collapse 
                v-model="activeName"
                class="isStyleBase" 
                accordion
              >
                <el-collapse-item 
                  v-for="(item,$index) in trafficInfo"
                  :key="$index"
                  :name="$index"
                  :title="item.title"
                >
                  <div v-html="item.content"></div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div> -->
        <div class="location__other">
          <div class="row location__other__list">
            <div
              v-for="(otherItem,$index) in otherSite"
              :key="$index"
              class="col-md-6 location__other__item"
            >
              <div class="location__other__box">
                <BaseSectionTitle2 :title="otherItem.title"/>
                <ul class="list-unstyled">
                  <li v-if="otherItem.map">
                    地址：
                    <a
                      :href="`https://www.google.com.tw/maps/search/${otherItem.map}`"
                      target="_blank"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      {{ otherItem.map }}
                    </a>
                    <img src="@assets/images/about/mapIcon.svg" alt="" style="padding-bottom: 7px;">
                  </li>
                  <li v-if="otherItem.tel">
                    電話：
                    <a
                      :href="`tel:${otherItem.tel}`"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      {{ otherItem.tel }}
                    </a>
                  </li>
                  <li v-if="otherItem.fax">
                    傳真：
                    <a
                      :href="`tel:${otherItem.fax}`"
                      class="text-gray-7 hover:text-primary-hover text-decoration-none link"
                    >
                      {{ otherItem.fax }}
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </ContactLayout>
</template>
<style lang="scss" module>
  .location {
    :global {
      .location {
        &__head {
          &__list {

          }

          &__item {
            .img {
              width: 100%;
              height: 602px;
              background-image: url('~@src/assets/images/info/location/image.jpg');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;

              @include max-md {
                height: auto;
                padding-top: 60%;
              }
            }

            &--right {
              padding-top: 40px;
              padding-bottom: 20px;
              padding-left: 50px;

              @include max-md {
                padding-left: 0;
              }

              ul {
                margin-top: 60px;
                line-height: 1.75;

                li {
                  &:not(:first-child) {
                    margin-top: 5px;
                  }

                  .link {
                    transition: .3s;
                  }
                }
              }

              .el-collapse-item {
                &__header {
                  padding-top: 1rem;
                  padding-bottom: 1rem;
                  font-size: 1.12rem;
                  font-weight: 400;
                }

                &__content {
                  padding-top: 1.5rem;
                  padding-right: 20px;
                  padding-bottom: 1.5rem;
                  padding-left: 20px;
                }
              }
            }
          }

        }

        &__other {
          // padding-top: 130px;
          &__list {
            margin-top: -60px;

            @include max-md {
              margin-top: -2rem;
            }
          }

          &__item {
            margin-top: 60px;

            @include max-md {
              margin-top: 2rem;
            }
          }

          &__box {
            height: 347px;
            padding: 80px 90px;
            background: #FFF 0% 0% no-repeat padding-box;;
            border: 1px solid #E6E6E6;
            border-radius: 0 2px 2px 0;
            box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);

            @include max-md {
              height: auto;
              padding: 2rem 1rem;
            }

            ul {
              line-height: 1.75;

              li {
                &:not(:first-child) {
                  margin-top: 5px;
                }

                .link {
                  margin-left: -5px;
                  transition: .3s;
                }
              }
            }
          }
        }
      }
    }


  }
</style>
